<template>
  <div class="animated fadeIn">
    <b-tabs v-model="tabIndex">
      <b-tab :title="'Pesquisar'">
          <template slot="title">
            <div><i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third"> Pesquisar</span></div>
          </template>
          <ExpenseSearch ref="Search"
                  v-on:Edit="onEditExpense"
                  v-on:New="onNewExpense"
                  v-on:Delete="onDeleteExepense"
                  v-on:Clear="onClear" />
        </b-tab>
      <b-tab :title="'Despesas'" @click="onLoadDetails">
        <template slot="title">
          <i class="fas fa-money-check-alt text-third"></i><span class="d-md-down-none pl-1 text-third"> Despesas</span>
        </template>
        <ExpenseDetails ref="ExpenseDetails" />
      </b-tab>
      <b-tab :title="'Comprovantes'" @click="onLoadAttachment" v-if="false">
        <template slot="title">
          <i class="fas fa-paperclip text-third"></i><span class="d-md-down-none pl-1 text-third"> Comprovantes</span>
        </template>
        <ExpenseAttachment ref="ExpenseAttachment" />
      </b-tab>
      <b-tab :title="'Termo'">
        <template slot="title">
          <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Termo</span>
        </template>
        <ExpenseTerm ref="ExpenseTerm" />
      </b-tab>
      <b-tab :title="'Autorizações'" @click="onLoadAuthorization">
        <template slot="title">
          <i class="fas fa-user-lock text-third"></i><span class="d-md-down-none pl-1 text-third"> Autorizações</span>
        </template>
        <ExpenseAuthorization ref="ExpenseAuthorization" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import ExpenseSearch from './search/search.vue'
import ExpenseDetails from './details/details.vue'
import ExpenseAttachment from './attachment/attachment.vue'
import ExpenseTerm from './term/consentterm.vue'
import ExpenseAuthorization from './authorizations/authorizations.vue'

import ActionsForm from '@/shared/mixins/actionsForm'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import TermType from '@/shared/utils/termtype.js'
import { loading } from '@/shared/utils/UIHelper'

const Tabs = {
  SEARCH: 0,
  EXPENSES: 1,
  ATTACHEMNT: 2,
  TERM: 3,
  AUTHORIZATION: 4
}

export default {
  mixins: [ ActionsForm ],
  name: 'MiscellaneousExpenses',
  data () {
    return {
      obj: null,
      objSelected: null,
      tabIndex: Tabs.SEARCH,
      typeTerm: TermType
    }
  },
  components: {
    ExpenseSearch,
    ExpenseDetails,
    ExpenseAttachment,
    ExpenseTerm,
    ExpenseAuthorization
  },
  methods: {
    onClear () {
    },
    onNewExpense () {
      AcceptanceTermRepository.GetExist(this.CompanySelected, this.typeTerm.MISCELLANEOUS_EXPENSES)
        .then((response) => {
          if (response.data.code > 0 && response.data.data != null && response.data.data.dataAprovacao != null) {
            this.$refs.ExpenseDetails.onAddExpense()
            this.tabIndex = Tabs.EXPENSES
          } else {
            this.$refs.ExpenseTerm.onLoadTerm(response.data.data)
            this.tabIndex = Tabs.TERM
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEditExpense (obj) {
      this.objSelected = obj
      this.tabIndex = Tabs.EXPENSES
      this.$refs.ExpenseDetails.onEditExpense(obj)
    },
    onLoadDetails () {
      if (this.objSelected) {
        this.$refs.ExpenseDetails.onEditExpense(this.objSelected)
      }
    },
    onLoadAttachment () {
      if (this.objSelected) {
        this.$refs.ExpenseAttachment.onEditExpense(this.objSelected)
      }
    },
    onLoadAuthorization () {
      this.tabIndex = Tabs.AUTHORIZATION
      this.$refs.ExpenseAuthorization.onLoadAuthorization()
    },
    onDeleteExepense (obj) {
      console.log('DELETE DESPESA')
      console.log(obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/miscellaneousexpenses.vue